import { useMemo } from "react"
import { GetApp } from "../../App"
import { GetShipUsers } from "../ShipView"
import { BlockField, BlockRow } from "../../Components/Block"
import { PrintWatchGroupViewProps } from "./Params"

export function PrintWatchGroupView({ group, index: _index }: PrintWatchGroupViewProps) {
  const app = GetApp();
  const shipUsers = GetShipUsers();
  const t = app.getT("DayWatchView_groups");

  const peopleNames = useMemo(() => {
    if (!group.people || group.people.length === 0 || !shipUsers) return "";
    return group.people.map((id) => {
      const user = shipUsers.find((u) => u.id === id);
      return user ? user.name || "" : "";
    }).filter((name) => name).join(", ");
  }, [group.people, shipUsers]);

  return (
    <BlockRow className="print-day-watch-groups">
      <BlockField label={t("name")} className="block-field-120">{group.name}</BlockField>
      <BlockField label={t("people")} className="">{peopleNames}</BlockField>
    </BlockRow>
  );
}
